import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Layout from '../components/Layout';

const LayoutPrivate = ({ children }) => {
  const { currentUser } = useAuth();
  // Força desativar bypass também aqui para produção
  const bypassAuth = false;

  if (!currentUser && !bypassAuth) {
    return <Navigate to="/acesso-interno" replace />;
  }

  return <Layout>{children}</Layout>;
};

export default LayoutPrivate;
